/**
 * Created by YJZX-LCH on 2017-04-12.
 */
import NetTool from '../../api/netTool';

const state = {
  photos: [],
  page: 0,
  pageCount: 0,
  disable: false,
  scrollTop: 0,
  loadingState: 1  // 1-正常隐藏状态 2-加载状态 3-到底状态 4-nothing状态 5-网络情况差
};

const getters = {
  photosInfo (state) {
    return state;
  },
  loadingText (state) {
    let text = '';
    switch (state.loadingState) {
      case 1:
        text = '';
        break;
      case 2:
        text = '加载中...';
        break;
      case 3:
        text = '没有更多内容';
        break;
      case 4:
        text = '您还没有照片';
        break;
      case 5:
        text = '请检查您的网络';
        break;
    }
    return text;
  }
};

const mutations = {
  clearPhotosInfo (state) {
    state.photos = [];
    state.page = 0;
    state.scrollTop = 0;
    state.pageCount = 0;
    state.disable = false;
    state.loadingState = 1;
  },
  setScrollTop (state, top) {
    state.scrollTop = top;
  },
  setPhotos (state, {photos}) {
    state.photos = photos;
  },
  addPhotos (state, {photos}) {
    state.photos = state.photos.concat(photos);
  },
  setPage(state, page) {
    state.page = page;
  },
  pageAdd(state) {
    state.page++;
  },
  setPageCount(state, pageCount) {
    state.pageCount = pageCount;
  },
  setDisable(state, disable) {
    state.disable = disable;
  },
  setLoadingState (state, status) {
    state.loadingState = status;
  }
};

const actions = {
  getPhotos ({commit, state}, payload) {
    commit('pageAdd');
    commit('setDisable', true);
    NetTool.photos(state.page).then(response => {
      if (response.errno === '0') {
        if (state.page === 1) {
          commit('setPhotos', {photos: response.result});
        } else {
          commit('addPhotos', {photos: response.result});
        }
        commit('setPage', response._meta.currentPage);
        commit('setPageCount', response._meta.pageCount);
        commit('setDisable', state.page >= state.pageCount);
        if (state.disable) {
          if (state.photos.length === 0) {
            commit('setLoadingState', 4);
          } else {
            commit('setLoadingState', 3);
          }
        } else {
          commit('setLoadingState', 1);
        }
      } else {
        payload.toastInfo(response.message);
      }
    }).catch(e => {
      console.log(e);
      commit('setLoadingState', 5);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/photos.js